export function deepEqual(obj1, obj2) {
  // Check if both are null or undefined
  if (obj1 === obj2) {
    return true;
  }

  // Check if both are not objects or if either is null
  if (
    typeof obj1 !== 'object' ||
    obj1 === null ||
    typeof obj2 !== 'object' ||
    obj2 === null
  ) {
    return false;
  }

  // Get keys of both objects
  let keys1 = Object.keys(obj1);
  let keys2 = Object.keys(obj2);

  // Check if lengths of keys arrays are different
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Check if keys and values are equal recursively
  for (let key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}
